// extracted by mini-css-extract-plugin
export default {"divNotification":"Notification_divNotification__Hh9lR"};